import classNames from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import styles from './collapse-panel.module.scss'
import { useLocalStorage } from '@BUP/hooks/useLocalStorage'
import { Collapse } from 'react-collapse'

const CollapsePanel = ({
  label,
  children,
  arrowColor = '#2F3838',
  bgColor,
  shadow = false,
  id,
  borderBottom,
  buttonColor,
  borderRadiusBottom,
  isOpenCollapse = false
}) => {
  const initialValue = { id, isOpen: isOpenCollapse }
  const [collapseState, setCollapseState] = useLocalStorage(
    'collapseState',
    initialValue
  )
  const { isOpen } = collapseState

  const classNameContainer = classNames(`${styles.container}`, {
    [styles.shadow]: shadow
  })

  const classNameButton = classNames(`${styles.button_content}`, {
    [styles.border_bottom]: borderBottom === true
  })

  const toggleCollapse = id => {
    setCollapseState({ id, isOpen: !collapseState.isOpen })
  }

  return (
    <div
      className={classNameContainer}
      style={{ backgroundColor: bgColor }}
    >
      <div
        onClick={() => toggleCollapse(id)}
        className={styles.button}
        style={{
          backgroundColor: buttonColor,
          ...(borderRadiusBottom && { borderRadius: '0 0 8px 8px' })
        }}
      >
        <div className={classNameButton}>
          {label}{' '}
          <span>
            <FontAwesomeIcon
              icon={faChevronDown}
              size='xl'
              style={{
                transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform ease-in-out 0.5s',
                color: arrowColor
              }}
            />
          </span>
        </div>
      </div>
      <Collapse isOpened={collapseState.isOpen}>
        {collapseState.isOpen &&
          <div>
            <div className={styles.content}>
              {children}
            </div>
          </div>}
      </Collapse>
    </div>
  )
}

export default CollapsePanel
